module.exports = __webpack_public_path__ + "static/media/彩之云平台功能清单.754740ff.docx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xieyi/彩之云平台功能清单.docx
// module id = 549
// module chunks = 0